import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

import TimecardStatsHideIcon from '../../common/icons/TimecardStatsHideIcon';

export default function TimecardHeaderStatCard({
  statKey,
  label,
  value,
  valueClassName,
  onHide,
}) {
  return (
    <div className="timecard-header-stat">
      <Tooltip title="Hide hours breakdown panel">
        <button
          type="button"
          className="timecard-header-stat-hide"
          aria-label={`Hide ${label}`}
          onClick={() => onHide(statKey)}
        >
          <TimecardStatsHideIcon />
        </button>
      </Tooltip>
      <div className="timecard-header-stat-label">{label}</div>
      <div className={`timecard-header-stat-value ${valueClassName}`}>{value}</div>
    </div>
  );
}

TimecardHeaderStatCard.propTypes = {
  statKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  valueClassName: PropTypes.string,
  onHide: PropTypes.func.isRequired,
};

TimecardHeaderStatCard.defaultProps = {
  valueClassName: '',
};
